import React, { useState, useEffect, useRef } from "react";
import { RESTExecutor, withDomains } from "../../lib/domain";
import "antd/dist/antd.css";
import { Button, Checkbox, message, Card } from "antd";
import { InputOTP } from "antd-input-otp";
import CustomOTPInput from "../../components/CustomOTPInput";
import { useHistory } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const ENCRYPTION_KEY =
  process.env.REACT_APP_ENCRYPTION_KEY || "981239812312312323";
const OTP_LENGTH = 6;
const RESEND_TIMER_SECONDS = 60;
const Timer = ({ isActive, onResend, initialSeconds = 60 }) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isRunning, setIsRunning] = useState(isActive);

  useEffect(() => {
    if (isActive) {
      setSeconds(initialSeconds);
      setIsRunning(true);
    }
  }, [isActive, initialSeconds]);

  useEffect(() => {
    let interval = null;
    if (isRunning && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsRunning(false);
    }
    return () => clearInterval(interval);
  }, [isRunning, seconds]);

  const handleResend = () => {
    setSeconds(initialSeconds);
    setIsRunning(true);
    onResend();
  };

  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  if (seconds > 0) {
    return (
      <div style={{ alignSelf: "stretch" }}>
        <span
          style={{
            color: "#969798",
            fontSize: 14,
            fontFamily: "Inter",
            fontWeight: "400",
            lineHeight: "21px",
            wordWrap: "break-word",
          }}
        >
          Didn't receive a code?
        </span>
        <span
          style={{
            color: "#969798",
            fontSize: 14,
            fontFamily: "Inter",
            fontWeight: "500",
            lineHeight: "21px",
            wordWrap: "break-word",
          }}
        >
          {" "}
        </span>
        <span
          style={{
            color: "#143E9F",
            fontSize: 14,
            fontFamily: "Inter",
            fontWeight: "500",
            lineHeight: "21px",
            wordWrap: "break-word",
          }}
        >
          Resend in{" "}
        </span>
        <span
          style={{
            color: "#143E9F",
            fontSize: 14,
            fontFamily: "Inter",
            fontWeight: "700",
            lineHeight: "21px",
            wordWrap: "break-word",
          }}
        >
          {formatTime(seconds)}
        </span>
      </div>
    );
  }

  return (
    <div style={{ alignSelf: "stretch" }}>
      <span
        style={{
          color: "#969798",
          fontSize: 14,
          fontFamily: "Inter",
          fontWeight: "400",
          lineHeight: "21px",
          wordWrap: "break-word",
        }}
      >
        Didn't receive a code?
      </span>
      <span
        style={{
          color: "#969798",
          fontSize: 14,
          fontFamily: "Inter",
          fontWeight: "500",
          lineHeight: "21px",
          wordWrap: "break-word",
        }}
      >
        {" "}
      </span>
      <span
        onClick={handleResend}
        style={{
          color: "#143E9F",
          fontSize: 14,
          fontFamily: "Inter",
          fontWeight: "500",
          lineHeight: "21px",
          wordWrap: "break-word",
          cursor: "pointer",
        }}
      >
        Resend verification code
      </span>
    </div>
  );
};

const VerificationForm = ({
  userEmail,
  otpValue,
  setOtpValue,
  handleFinish,
  setRememberDevice,
  timerActive,
  handleResendCode,
  auth_resp,
  handleVerify,
  setOpen,
  deviceFingerprint,
  isVerifying,
  otpRef,
}) => {
  const history = useHistory();

  return (
    <div>
      <p className="form-header-verify">Verify it's you</p>
      <p className="form-sub-header-verify">
        Verification code sent to <span className="primary"> {userEmail}</span>
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CustomOTPInput
          ref={otpRef}
          length={OTP_LENGTH}
          value={otpValue}
          onChange={(newValue) => {
            setOtpValue(newValue);
          }}
          onComplete={(otpArray) => {
            setTimeout(() => {
              handleVerify(otpArray);
            }, 100);
          }}
          autoSubmit={true}
          className="otp-input-container"
        />
      </div>
      {/* <Checkbox
      id="normal_login_remember"
      style={{ margin: "10px 0px" }}
      initialValues={{ trust_device: true }}
      checked={rememberDevice}
      onChange={(event) => {
        setRememberDevice(event.target.checked);
      }}
    >
      Trust this Device for 60 days?
    </Checkbox> */}

      <Timer
        isActive={timerActive}
        onResend={handleResendCode}
        initialSeconds={RESEND_TIMER_SECONDS}
      />

      <Button
        loading={auth_resp?.fetching || isVerifying}
        size="large"
        className="login-form-button-new"
        disabled={
          !deviceFingerprint ||
          (Array.isArray(otpValue)
            ? otpValue.filter((val) => val !== "").length !== OTP_LENGTH
            : otpValue.length !== OTP_LENGTH)
        }
        style={{
          marginTop: 16,
          width: "100%",
        }}
        onClick={handleVerify}
      >
        {!deviceFingerprint ? "Preparing..." : "Verify"}
      </Button>

      <div
        onClick={() => {
          setOpen(false);
          history.push("/");
        }}
        style={{
          textAlign: "center",
          cursor: "pointer",
          marginTop: 8,
        }}
        className="primary"
      >
        Return to Login
      </div>
    </div>
  );
};

function loadFromSessionStorage(data) {
  try {
    const serializedState = sessionStorage.getItem(data);
    if (serializedState === null) {
      return undefined;
    }
    const decrypted = CryptoJS.AES.decrypt(
      serializedState,
      ENCRYPTION_KEY,
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Error loading from session storage:", error);
    return undefined;
  }
}

function saveToSessionStorage(state) {
  try {
    const serializedState = JSON.stringify(state);
    const encrypted = CryptoJS.AES.encrypt(serializedState, ENCRYPTION_KEY);
    sessionStorage.setItem("regId", encrypted);
  } catch (error) {
    console.error("Session storage error:", error);
  }
}

const VerifyCodePage = ({ domains, ...props }) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const is_app_request = query.get("is_app_request");

  let { id, email } = loadFromSessionStorage("regId") || {};

  let userData = {};
  try {
    const encryptedUserData = sessionStorage.getItem("userData");
    if (encryptedUserData) {
      const decryptedUserData = CryptoJS.AES.decrypt(
        encryptedUserData,
        ENCRYPTION_KEY,
      ).toString(CryptoJS.enc.Utf8);
      userData = JSON.parse(decryptedUserData);
    }
  } catch (e) {
    console.error("Error loading user data:", e);
  }

  let resend_otp = RESTExecutor.post()
    .config({
      label: "resend_otp",
    })
    .callbacks(
      (success) => {
        saveToSessionStorage({ id: success.result.id, email: email });
        message.success(
          "Your code has been sent again. Please check your inbox or spam just in case.",
        );
      },
      (error) => {
        error.error_message && message.error(error.error_message);
      },
    )
    .connect(domains.register);

  let register_api = RESTExecutor.post()
    .config({
      label: "register_user",
    })
    .callbacks(
      (success) => {
        message.success("Registration completed successfully!");
        props.history.push({ pathname: `/sign-up` });
        if (is_app_request) {
          setTimeout(() => {
            if (window.flutter_inappwebview) {
              window.flutter_inappwebview.callHandler("registerComplete", {
                userId: 123,
              });
            }
          }, 1500);
        }
      },
      (error) => {
        error.error_message && message.error(error.error_message);
        console.error("Registration error:", error);
      },
    )
    .connect(domains.register);

  let verify_code = RESTExecutor.post()
    .config({
      label: "verify_code",
    })
    .callbacks(
      (success) => {
        const registrationData = {
          id: id,
          email: email,
          name: userData.name,
          passowrd: userData.passowrd,
          confirm_password: userData.confirm_password,
          phone_number: userData.phone_number,
        };

        if (
          !registrationData.name ||
          !registrationData.passowrd ||
          !registrationData.phone_number
        ) {
          message.error(
            "Registration data is incomplete. Please start the registration process again.",
          );
          sessionStorage.removeItem("userData");
          sessionStorage.removeItem("regId");
          props.history.push("/register");
          return;
        }

        register_api.execute(registrationData);
      },
      (error) => {
        setIsVerifying(false);
        if (error?.error_message) {
          message.error(error.error_message);
        }
        if (error?.validation_errors && error.validation_errors["id"]) {
          message.error(error.validation_errors["id"]);
        }
        setOtpValue(["", "", "", "", "", ""]);
        setTimeout(() => {
          if (otpRef.current) {
            otpRef.current.focusFirst();
          }
        }, 100);
      },
    )
    .connect(domains.register);

  let verify_resp = verify_code.response();

  const [otpValue, setOtpValue] = useState([]);
  const [timerActive, setTimerActive] = useState(true);
  const [rememberDevice, setRememberDevice] = useState(false);
  const [open, setOpen] = useState(true);
  const [userEmail, setUserEmail] = useState(email || "");
  const [deviceFingerprint, setDeviceFingerprint] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const otpRef = useRef(null);

  const handleFinish = () => {
    setTimeout(() => {
      handleVerify();
    }, 100);
  };

  const handleVerify = (customOtpValue = null) => {
    const otpCode = customOtpValue
      ? Array.isArray(customOtpValue)
        ? customOtpValue.join("")
        : customOtpValue
      : Array.isArray(otpValue)
        ? otpValue.join("")
        : otpValue;

    if (!otpCode || otpCode.length !== OTP_LENGTH) {
      message.error(
        `Please enter a complete ${OTP_LENGTH}-digit verification code`,
      );
      return;
    }

    setIsVerifying(true);
    let data = { code: otpCode, id: id };
    verify_code.execute(data);
  };

  const handleResendCode = () => {
    resend_otp.execute({ email: email });
    setTimerActive(true);
  };

  useEffect(() => {
    const generateFingerprint = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.textBaseline = "top";
      ctx.font = '14px "Arial"';
      ctx.fillText("Device fingerprint", 2, 2);

      const fingerprint = {
        userAgent: navigator.userAgent,
        screen: `${window.screen.width}x${window.screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
        canvas: canvas.toDataURL(),
        timestamp: Date.now(),
      };

      return btoa(JSON.stringify(fingerprint));
    };

    setDeviceFingerprint(generateFingerprint());
  }, []);

  return (
    <>
      <style>{`
        /* Custom OTP Input Styles */
        .custom-otp-container {
          display: flex;
          justify-content: center;
          gap: 8px;
          width: 100%;
        }

        .custom-otp-input {
          width: 56px !important;
          height: 64px !important;
          min-width: 56px !important;
          max-width: 56px !important;
          border: 1px solid #E0E5EB !important;
          border-radius: 8px !important;
          text-align: center !important;
          font-size: 24px !important;
          font-weight: 600 !important;
          color: #343C46 !important;
          background: #FAFAFA !important;
          outline: none !important;
          transition: border-color 0.15s ease !important;
          caret-color: #143E9F !important;
          font-family: 'Inter', sans-serif !important;
        }

        .custom-otp-input:focus {
          border-color: #143E9F !important;
          box-shadow: none !important;
          background: #FAFAFA !important;
        }

        .custom-otp-input:not(:placeholder-shown):not(:focus) {
          border-color: #E0E5EB !important;
          background: #FAFAFA !important;
        }

        /* Mobile responsive custom OTP inputs */
        @media (max-width: 768px) {
          .custom-otp-container {
            gap: 6px;
          }
          
          .custom-otp-input {
            width: 40px !important;
            height: 48px !important;
            min-width: 40px !important;
            max-width: 40px !important;
            font-size: 18px !important;
            border-radius: 6px !important;
          }
        }

        @media (max-width: 480px) {
          .custom-otp-container {
            gap: 4px;
          }
          
          .custom-otp-input {
            width: 36px !important;
            height: 44px !important;
            min-width: 36px !important;
            max-width: 36px !important;
            font-size: 16px !important;
            border-radius: 4px !important;
          }
        }

        /* Legacy OTP Input Responsive Styles (kept for compatibility) */
        .otp-input-container {
          display: flex;
          justify-content: center;
          gap: 8px;
          width: 100%;
        }

        .form-header-verify {
          color: #343C46;
          font-size: 24px;
          font-family: 'Inter';
          font-weight: 700;
          margin-bottom: 8px;
          text-align: center;
        }

        .form-sub-header-verify {
          color: #969798;
          font-size: 14px;
          font-family: 'Inter';
          font-weight: 400;
          margin-bottom: 20px;
          text-align: center;
        }

        .primary {
          color: #143E9F;
          font-weight: 700;
        }

        .login-form-button-new {
          background: #143E9F !important;
          border: none !important;
          color: white !important;
          font-size: 14px !important;
          font-family: 'Inter' !important;
          font-weight: 600 !important;
          height: 48px !important;
          border-radius: 6px !important;
          box-shadow: 0px 8px 24px -8px rgba(20, 62, 159, 0.16) !important;
        }

        .login-form-button-new:hover {
          background: #0f2d7a !important;
          color: white !important;
        }

        .login-form-button-new:disabled {
          background: #bfc3c9 !important;
          color: white !important;
          cursor: not-allowed !important;
        }

        .verification-card-custom {
          width: 464px !important;
          max-width: 550px !important;
          padding: 40px 32px !important;
          background: #FAFAFA !important;
          box-shadow: 0px 28px 62px rgba(37, 78, 207, 0.03) !important;
          border-radius: 16px !important;
          border: none !important;
        }

        .verification-card-custom .ant-card-body {
          padding: 0 !important;
        }

        .ant-checkbox-wrapper {
          font-family: 'Inter' !important;
          font-size: 14px !important;
          color: #969798 !important;
        }

        .ant-checkbox-checked .ant-checkbox-inner {
          background-color: #143E9F !important;
          border-color: #143E9F !important;
        }

        .ant-checkbox:hover .ant-checkbox-inner {
          border-color: #143E9F !important;
        }

        .main-verification-container {
          width: 100vw;
          height: 100vh;
          background: #EEF2F7;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: 'Inter';
        }

        @media (max-width: 768px) {
          .verification-card-custom {
            width: 100% !important;
            max-width: 400px !important;
            padding: 32px 24px !important;
            margin: 20px !important;
          }

          .form-header-verify {
            font-size: 20px !important;
          }

          .form-sub-header-verify {
            font-size: 12px !important;
          }
        }

        @media (max-width: 480px) {
          .verification-card-custom {
            padding: 24px 20px !important;
            margin: 16px !important;
          }

          .form-header-verify {
            font-size: 18px !important;
          }
        }
      `}</style>

      <div className="main-verification-container">
        <Card className="verification-card-custom">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 24,
            }}
          >
            <img
              src="images/logo2.svg"
              alt="Logo"
              style={{
                width: 60,
                height: 60,
              }}
            />

            <VerificationForm
              userEmail={userEmail}
              otpValue={otpValue}
              setOtpValue={setOtpValue}
              handleFinish={handleFinish}
              rememberDevice={rememberDevice}
              setRememberDevice={setRememberDevice}
              timerActive={timerActive}
              handleResendCode={handleResendCode}
              auth_resp={verify_resp}
              handleVerify={handleVerify}
              setOpen={setOpen}
              deviceFingerprint={deviceFingerprint}
              isVerifying={isVerifying}
              otpRef={otpRef}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default withDomains(VerifyCodePage, "register");
